<template>
	<div id="textbox"></div>
</template>

<script>
	import E from 'wangeditor'
	import axios from 'axios'
	export default{
		data(){
			return{
				token: this.$store.state.token, //token
				userid: this.$store.state.userid, //id
				editortext: ""
			}
		},
		methods:{
			gethtml(){
				return this.editortext
			}
		},
		mounted() {
			const editor = new E("#textbox")
			editor.config.menus = [
				'head', // 标题
				'bold', // 粗体
				'fontSize', // 字号
				'fontName', // 字体
				'underline', // 下划线
				'foreColor', // 文字颜色      
				'image', // 插入图片
				'undo', // 撤销
				'redo', // 重复
				'indent',//缩进
			]
			editor.config.zIndex = 1
			editor.config.showLinkImg = false
			//editor.config.uploadImgShowBase64 = true // base 64 存储图片
			editor.config.customUploadImg = (resultFiles, insertImgFn) => {
				let formData = new FormData()
				formData.append('file', resultFiles[0])
				axios.post(this.$api.commonUrl +'attachments/upload', formData, {
					headers: {
						"Authorization": this.scheme + " " + this.token,
						"Content-Type": "multipart/form-data"
					}
				}).then(res => {
					console.log(res.data);
					if (res.data.code == '200') {
						insertImgFn(this.$api.imgUrl + '' + res.data.data.fastFileId)
					}
				}, err => {
					console.log(err);
				})
			}
			editor.config.onchange = (html) => {
				this.isChange = true
				this.editortext = html
			}
			editor.create()
			if (this.type == 'edit') {
				this.querytext(editor)
			}
		}
	}
</script>

<style scoped>
	#textbox{
		background: rgba(0,0,0,0);
	}
</style>
